module.exports = __webpack_public_path__ + "static/media/CrimsonText-Regular.62f10d46.ttf";